import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ModelPopupTypes } from '@frontend/sports/navigation/core/feature/url-helper';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Store } from '@ngrx/store';
import { PopupManager } from 'packages/sports/web/app/src/popup/popup-manager.service';

import { EditBetActions } from '../../actions';
import { EditBetOnBoardingService } from '../../services/betslip-onboarding.service';

@Component({
    selector: 'bs-betslip-edit-mybet-header',
    templateUrl: './edit-bet-header.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-header.scss'],
    standalone: false,
})
export class EditMybetHeaderComponent {
    constructor(
        public siteCore: Sitecore,
        private onBoardingService: EditBetOnBoardingService,
        private trackingService: TrackingService,
        private store: Store,
        private popupManager: PopupManager,
    ) {}

    onCancelClick(): void {
        this.popupManager.updateDialogAnimation(ModelPopupTypes.MyBets, undefined, false, false);
        this.store.dispatch(EditBetActions.requestDiscard());
    }

    onInfoClick(): void {
        this.trackingService.track(trackingConstants.EVENT_EDIT_BET, {
            [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_Info_Clicked',
            [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
        });
        this.onBoardingService.openDialog();
    }
}
